module.exports = __webpack_public_path__ + "static/media/sur-place.db1d1c94.svg";